import React from 'react';
import './BenefitsSection.css';

// Importe os ícones dos benefícios
import iconTime from '../../assets/tdesign_time-filled.svg'; 
import iconErrors from '../../assets/material-symbols_back-hand-rounded.svg';
import iconVisual from '../../assets/material-symbols_table-eye-sharp.svg';
import iconEfficiency from '../../assets/mdi_shield-check.svg';

function BenefitsSection() {
  const benefits = [
    { icon: iconTime, text: 'OTIMIZAÇÃO DE TEMPO' },
    { icon: iconErrors, text: 'REDUÇÃO DE ERROS MANUAIS' },
    { icon: iconVisual, text: 'VISUALIZAÇÃO INTUITIVA' },
    { icon: iconEfficiency, text: 'EFICIÊNCIA OPERACIONAL' },
  ];

  return (
    <section id="beneficios" className="benefits-section">
      <div className="container">
        <span className="subtitle">NOSSA SOLUÇÃO</span>
        <h2>
          Benefícios do DLOGIC
          <span className="underline"></span> 
        </h2>

        <div className="benefits-grid">
          {benefits.map((benefit, index) => (
            <div className="benefit-item" key={index}>
              <img src={benefit.icon} alt={benefit.text} className="benefit-icon" />
              <p className="benefit-text">{benefit.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default BenefitsSection;